import {connect} from "react-redux";
import {CButton, CCol, CFormInput, CFormSelect, CInputGroup, CInputGroupText, CRow} from "@coreui/react";
import React from "react";

const StoreDetail = (props) => {
	const {info} = props;
	const save = () => {
		props.save();
	}

	const init = () => {
		props.init();
	}

	const storeSearch = () => {
		props.search();
	}

	return (
		<>
			<div className="d-grid gap-1 d-md-flex justify-content-between"
				 style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
				<h5>[{info.storeCd}] {info.storeNm}</h5>
				<div className="d-grid gap-1 d-md-flex justify-content-md-end">
					<CButton size={"sm"} color="dark" onClick={init}>신규</CButton>
					<CButton size={"sm"} color="dark" onClick={save}>저장</CButton>
				</div>
			</div>
			<CRow>
				<CCol xs={8}>
					<CInputGroup className={"mb-1"} size={"sm"}>
						<CInputGroupText style={{width: 100}}>사업자번호</CInputGroupText>
						<CFormInput id="busiNo" value={info.busiNo}
									maxLength={10}
									onChange={(e) => {
										props.handler((state) => ({
											...state,
											busiNo: e.target.value
										}))
									}}/>
						<CFormInput id="taxidx" value={info.taxidx}
									maxLength={4}
									onChange={(e) => {
										props.handler((state) => ({
											...state,
											taxidx: e.target.value
										}))
									}}/>
						<CButton onClick={storeSearch}>조회</CButton>
					</CInputGroup>
				</CCol>
			</CRow>
			<CRow>
				<CCol xs={6}>
					<CInputGroup className={"mb-1"} size={"sm"}>
						<CInputGroupText style={{width: 100}}>매장코드/명</CInputGroupText>
						<CFormInput id="storeCd" value={props.storeCd}
									onChange={(e) => {
										props.setStoreCd(e)
									}}
									disabled={info.storeCd !== null}/>
						<CFormInput id="storeNm" value={info.storeNm} onChange={(e) => {
							props.handler((state) => ({
								...state, storeNm: e.target.value
							}))
						}}/>
					</CInputGroup>
				</CCol>
				<CCol xs={6}>
					<CInputGroup className={"mb-1"} size={"sm"}>
						<CInputGroupText style={{width: 100}}>대표자명</CInputGroupText>
						<CFormInput id="ownerNm" value={info.ownerNm}
                                    onChange={e => {
                                        props.handler(state => ({
                                            ...state, ownerNm: e.target.value
                                        }))
                                    }}/>
					</CInputGroup>
				</CCol>
			</CRow>
			<CRow>
				<CCol xs={6}>
					<CInputGroup className={"mb-1"} size={"sm"}>
						<CInputGroupText style={{width: 100}}>매장형태</CInputGroupText>
						<CFormSelect id="state" onChange={e => {
                            props.handler(state => ({
                                ...state, manageDiv: e.target.value
                            }))
                        }}>
							<option value={"1"}>직영</option>
							<option value={"2"}>가맹</option>
							<option value={"3"}>일반</option>
						</CFormSelect>
					</CInputGroup>
				</CCol>
				<CCol xs={6}>
					<CInputGroup className={"mb-1"} size={"sm"}>
						<CInputGroupText style={{width: 100}}>매장그룹</CInputGroupText>
						<CFormSelect id="state">
							<option value={"100"}>[100] 일반</option>
						</CFormSelect>
					</CInputGroup>
				</CCol>
			</CRow>
			<CRow>
				<CCol xs={6}>
					<CInputGroup className={"mb-1"} size={"sm"}>
						<CInputGroupText style={{width: 100}}>전화번호</CInputGroupText>
						<CFormInput id="telNo" value={info.telNo ?? ""}
                                    onChange={e => {
                                        props.handler(state => ({
                                            ...state, telNo: e.target.value
                                        }))
                                    }}/>
					</CInputGroup>
				</CCol>
				<CCol xs={6}>
					<CInputGroup className={"mb-1"} size={"sm"}>
						<CInputGroupText style={{width: 100}}>핸드폰</CInputGroupText>
						<CFormInput id="rpresPhno" value={info.rpresPhno ?? ""}
									onChange={e => {
										props.handler(state => ({
											...state, rpresPhno: e.target.value
										}))
									}}/>
					</CInputGroup>
				</CCol>
			</CRow>
			<CRow>
				<CCol xs={6}>
					<CInputGroup className={"mb-1"} size={"sm"}>
						<CInputGroupText style={{width: 100}}>팩스</CInputGroupText>
						<CFormInput id="faxNo" value={info.faxNo ?? ""}
									onChange={e => {
										props.handler(state => ({
											...state, faxNo: e.target.value
										}))
									}}/>
					</CInputGroup>
				</CCol>
				<CCol xs={6}>
					<CInputGroup className={"mb-1"} size={"sm"}>
						<CInputGroupText style={{width: 100}}>E-mail</CInputGroupText>
						<CFormInput id="email" value={info.email ?? ""}
									onChange={e => {
										props.handler(state => ({
											...state, email: e.target.value
										}))
									}}/>
					</CInputGroup>
				</CCol>
			</CRow>
			<CRow>
				<CCol xs={6}>
					<CInputGroup className={"mb-1"} size={"sm"}>
						<CInputGroupText style={{width: 100}}>주소</CInputGroupText>
						<CFormInput id="addr1" value={info.addr1 ?? ""}
                                    onChange={e => {
                                        props.handler(state => ({
                                            ...state, addr1: e.target.value
                                        }))
                                    }}/>
					</CInputGroup>
				</CCol>
				<CCol xs={6}>
					<CInputGroup className={"mb-1"} size={"sm"}>
						<CInputGroupText style={{width: 100}}>상세주소</CInputGroupText>
						<CFormInput id="addr2" value={info.addr2 ?? ""}
                                    onChange={e => {
                                        props.handler(state => ({
                                            ...state, addr2: e.target.value
                                        }))
                                    }}/>
					</CInputGroup>
				</CCol>
			</CRow>
			<CRow>
				<CCol xs={6}>
					<CInputGroup className={"mb-1"} size={"sm"}>
						<CInputGroupText style={{width: 100}}>상태구분</CInputGroupText>
						<CFormSelect id="useYn" onChange={e => {
							props.handler(state => ({
								...state, useYn: e.target.value
							}))
						}}>
							<option value={"Y"}>사용</option>
							<option value={"N"}>미사용</option>
						</CFormSelect>
					</CInputGroup>
				</CCol>
				<CCol xs={6}>
					<CInputGroup className={"mb-1"} size={"sm"}>
						<CInputGroupText style={{width: 100}}>매장오픈일자</CInputGroupText>
						<CFormInput id="openDate" value={info.openDate ?? ""}
									onChange={e => {
										props.handler(state => ({
											...state, openDate: e.target.value
										}))
									}}/>

					</CInputGroup>
				</CCol>
			</CRow>
			<CRow>
				<CCol xs={6}>
					<CInputGroup className={"mb-1"} size={"sm"}>
						<CInputGroupText style={{width: 100}}>비밀번호</CInputGroupText>
						<CFormInput id="authPassword"
									value={info.authPassword ?? ""}
									onChange={e => {
										props.handler(state => ({
											...state, authPassword: e.target.value
										}))
									}}/>
					</CInputGroup>
				</CCol>
			</CRow>
			<div className="d-grid gap-1" style={{marginTop: 10}}>
				<CButton onClick={save}>저장</CButton>
			</div>
		</>
	)
}

const mapStateToProps = (state) => {
	const {account, store} = state;
	return {
		account, store
	};
};

StoreDetail.defaultProps = {
	info: {}
}

export default connect(mapStateToProps, null)(StoreDetail);
